import { ComponentProps } from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, onFocus, onMouseUp, ...props }: ComponentProps<"textarea">) {
  const placeCaretToEnd = (el: HTMLTextAreaElement) => {
    try {
      const len = el.value ? el.value.length : 0
      if (typeof el.setSelectionRange === 'function') {
        setTimeout(() => {
          try { el.setSelectionRange(len, len) } catch {}
        }, 0)
      }
    } catch {}
  }
  return (
    <textarea
      autoComplete="off"
      autoCorrect="off"
      spellCheck={false}
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      onFocus={(e) => { try { placeCaretToEnd(e.currentTarget) } catch {}; onFocus?.(e) }}
      onMouseUp={(e) => { try { placeCaretToEnd(e.currentTarget) } catch {}; onMouseUp?.(e) }}
      {...props}
    />
  )
}

export { Textarea }
